/**
 * Vertically aligns the pinned product-page share button with the price line.
 *
 * The share control is absolutely positioned in the product info card (see
 * component-product-share.css). Its `top` is measured from the card, so on its
 * own it sits level with the title. Titles run one or two lines depending on the
 * product and the viewport width, so a fixed offset can't stay on the price.
 * This centres the share button on the price block and re-runs whenever the card
 * reflows (e.g. the title rewraps at a different width). No JS = the CSS fallback
 * keeps it in the top-right corner, so the control is always usable.
 */
(function () {
  function align(container) {
    var share = container.querySelector('.share-button');
    var price = container.querySelector('[id^="price-"]');
    if (!share || !price) return;
    var top = price.offsetTop + price.offsetHeight / 2 - share.offsetHeight / 2;
    share.style.top = Math.max(0, Math.round(top)) + 'px';
  }

  function init() {
    document.querySelectorAll('.product__info-container').forEach(function (container) {
      if (!container.querySelector('.share-button')) return;
      align(container);
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          align(container);
        }).observe(container);
      } else {
        window.addEventListener('resize', function () {
          align(container);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
